import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import { FormControlLabel, Switch } from '@mui/material';
import format from 'string-template';

import Avatar from '../../../../../components/Avatar';
import AvatarSizeType from '../../../../../components/Avatar/AvatarSizes';
import UserContext from '../../../../../context/UserContext';
import LoggedInUserContext from '../../../../../context/LoggedInUserContext';

import {
  Container,
  RowContainer,
  StyledTitle,
} from './styles';
import texts from './texts.json';

const AgentProfileSection = () => {
  const { userDoc } = useContext(UserContext);
  const { userPresenceDoc } = useContext(LoggedInUserContext);

  const {
    avatarUrl,
    firstName,
    instaCallIS,
    isISOnCall,
  } = userDoc || {};

  return (
    <Container>
      <Avatar
        image={avatarUrl}
        name={firstName}
        avatarSize={AvatarSizeType.LARGE}
        isOnline={userPresenceDoc?.isOnline}
        showOnlineStatus
      />
      <RowContainer>
        <StyledTitle>{format(texts.title, { name: firstName })}</StyledTitle>
        {instaCallIS && (
          <FormControlLabel
            control={(
              <Switch
                checked={isISOnCall}
                onChange={(event) => userDoc.updateIsISOnCall(event.target.checked)}
              />
            )}
            label={texts.onCallLabel}
          />
        )}
      </RowContainer>
    </Container>
  );
};

export default compose(
  observer,
)(AgentProfileSection);
